import G2Icon from "@/components/icons/G2Icon";
import StarIcon from "@/components/icons/StarIcon";
import Image from "next/image";
import Link from "next/link";

export default function HeroSection() {
  return (
    <section id="hero-section">
      <div className="py-24 pt-36 pb-12 sm:pb-24 flex flex-col justify-center items-center">
        <div className="flex flex-col items-center justify-center gap-6">
          <div className="flex flex-col items-center justify-center">
            <div className="flex gap-1 items-center">
              <G2Icon className="text-[#0D2A4C26] size-5 sm:size-[30px] lg:mr-2" />
              <StarIcon className="text-[#0D2A4C26] size-5 sm:size-6" />
              <StarIcon className="text-[#0D2A4C26] size-5 sm:size-6" />
              <StarIcon className="text-[#0D2A4C26] size-5 sm:size-6" />
              <StarIcon className="text-[#0D2A4C26] size-5 sm:size-6" />
              <StarIcon className="text-[#0D2A4C26] size-5 sm:size-6" />
            </div>
            <h1 className="md:!text-7xl leading-[46px] md:leading-[78px] pt-2 tracking-tighter !text-[42px] !font-semibold max-w-[980px] text-wrap text-center text-[#0D2A4C] px-9">
              Search Over 710 Million Verified B2B Contacts
            </h1>
          </div>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-2.5">
            <Link
              href="/pricing"
              className="bg-[#2A8DFF] hover:bg-[#2A8DFF]/90 active:outline-1 active:outline-[#2A8DFF] active:bg-[#2A8DFF] !cursor-pointer px-8 text-center lg:py-[18px] py-[14px] rounded-[100px]"
            >
              <p className="text-lg text-white font-semibold">
                Get Started Now
              </p>
            </Link>
            <Link
              href="/demo-form"
              className="bg-[#F8F9FA] cursor-pointer hover:bg-white active:outline-1 active:outline-[#F8F9FA] active:bg-[#F8F9FA] w-full text-center sm:w-fit px-8 lg:py-[18px] py-[14px] border border-[#0D2A4C08] rounded-[100px]"
            >
              <p className="text-lg text-[#0D2A4C] font-semibold">
                Book a Demo
              </p>
            </Link>
          </div>
        </div>
      </div>
      <div className="justify-center hidden md:flex">
        <div className="relative max-w-[1000px] h-[350px] mx-6 w-full overflow-hidden">
          <Image
            src="/images/hero-image-app.webp"
            alt="Hero"
            width={1653}
            height={615}
            priority
            className="w-full"
          />
          {/* Bottom fade */}
          <div className="absolute bottom-0 left-0 w-full h-[350px] bg-gradient-to-t from-white to-transparent z-10" />
        </div>
      </div>
      <div className="relative h-[254px] w-full overflow-hidden px-[23px] flex md:hidden">
        <Image
          src="/images/hero-image-app-mobile.webp"
          alt="Hero"
          width={459}
          height={272}
          priority
          sizes="(max-width: 768px) 100vw, 688px"
          className="w-full h-auto"
          fetchPriority="high"
        />
        {/* Bottom fade */}
        <div className="absolute bottom-0 left-0 w-full h-[150px] bg-gradient-to-t from-white to-transparent z-10" />
      </div>
    </section>
  );
}
